import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { logo, COMPANY, NAV } from "@/data/site";

const explore = NAV.filter((n) => n.to !== "/");
const products = [
  { label: "Spelling App", to: "/apps/spelling" },
  { label: "Lesson Planner", to: "/apps/lesson-planner" },
];
const legal = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Use", to: "/terms" },
  { label: "Cookie Policy", to: "/cookies" },
];

function Col({ title, links }) {
  return (
    <div>
      <h4 className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-cream/50">{title}</h4>
      <ul className="space-y-2.5">
        {links.map((l) => (
          <li key={l.to}>
            <Link
              to={l.to}
              className="text-cream/80 transition-colors duration-200 hover:text-turquoise"
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="bg-purple text-cream" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Link to="/" className="flex items-center gap-3">
              <img src={logo} alt="FreeRange.Education" className="h-14 w-14 rounded-full" />
              <span className="font-display text-2xl font-bold tracking-tight">FreeRange.Education</span>
            </Link>
            <p className="mt-5 max-w-sm text-lg leading-relaxed text-cream/80">
              {COMPANY.positioning}
            </p>
            <a
              href={`mailto:${COMPANY.email}`}
              className="mt-6 inline-block font-semibold text-turquoise underline-offset-4 hover:underline"
              data-testid="footer-email"
            >
              {COMPANY.email}
            </a>
            <div className="mt-5">
              <a
                href="https://facebook.com/FreeRangeHomeEducation"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="FreeRange.Education on Facebook"
                data-testid="footer-facebook"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-cream/25 text-cream/70 transition-colors duration-200 hover:border-turquoise hover:text-turquoise"
              >
                <Facebook className="h-4 w-4" />
              </a>
            </div>
          </div>
          <Col title="Explore" links={explore} />
          <Col title="Products" links={products} />
          <Col title="Legal" links={legal} />
        </div>

        <div className="mt-16 grid gap-6 border-t border-cream/15 pt-8 md:grid-cols-2">
          <div className="text-sm leading-relaxed text-cream/70">
            <p className="font-semibold text-cream/90">FreeRange.Education is a brand operated by Sharls Ltd.</p>
            <p className="mt-2">
              {COMPANY.name} · {COMPANY.registered} · Company No. {COMPANY.companyNo}
            </p>
            <p>Registered Office: {COMPANY.office}</p>
          </div>
          <div className="text-sm text-cream/60 md:text-right">
            <p>© {new Date().getFullYear()} Sharls Ltd. All rights reserved.</p>
            <p className="mt-2">No advertising or behavioural tracking.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
